export const SAMPLETIMEZONE = {
  id: 0,
  countryId: 0,
  shortName: '',
  state: '',
  name: '',
};